import { getRndInteger } from '@/helpers/utilsHelper'

import { ModulesMap, MockMethodsMap } from '../../config/data/modulesMaps'

export default {

    [MockMethodsMap[ModulesMap.CACHE].GET_CACHE_HASHES]() {
        const hashes = {
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(hashes)
            }, getRndInteger(160, 420))
        })
    },

    [MockMethodsMap[ModulesMap.USER].GET_CURRENT_USER]() {
        const currentUser = {
            last_login: '2022-10-18T08:09:18+00:00', // Время последнего логина
            name: 'John Doe', // Имя
            is_active: 1, // Определяет Активен/Отключен ли пользователь
            is_staff: 0, // Является ли аккаунт сотрудником АгроОнлайн - открывает дополнительные возможности
            email_confirm: 1, // Подтвержден email - позволяет начать работать с системой
            date_joined: '2021-15-10T11:02:58+00:00', // Время регистрации
            language_code: 'ru', // Выбранный язык
            avatar: 'https://picsum.photos/1000/800', // Фото (путь)
            avatar_256x256: 'https://picsum.photos/256/256', // Уменьшенное фото (путь)
        }
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(currentUser)
            }, getRndInteger(600, 1000))
        })
    },

    [MockMethodsMap[ModulesMap.USER].GET_PERMISSIONS]() {
        return {
            "prices_view": 1,
            "contacts_view": 0,
            "material_view": 0,
            "material_edit": 0,
            "machine_view": 0,
            "machine_edit": 0,
            "machine_mount": 0,
            "restrict_job_order_delete": 0,
            "partner_can_change_access": 0,
            "partner_view": 0,
            "partner_edit": 0,
            "staff_view": 0,
            "staff_edit": 0,
            "staff_can_change": 0,
            "staff_view_activity": 0,
            "meteo_view": 0,
            "meteo_edit": 0,
            "analysis_view": 0,
            "analysis_edit": 0,
            "year_plans_view": 0,
            "year_plans_edit": 0,
            "land_holder_view": 0,
            "land_holder_edit": 0,
            "land_holder_view_contacts": 0,
            "route_view": 0,
            "route_edit": 0,
            "drone_view": 0,
            "drone_edit": 0,
            "infrastructure_view": 0,
            "infrastructure_edit": 0,
            "field_view": 0,
            "field_edit": 0,
            "field_view_related_crop_rotations": 0,
            "field_view_current_crop_rotations": 0,
            "technology_view": 0,
            "technology_edit": 0,
            "technologicalcard_view": 0,
            "technologicalcard_edit": 0,
            "crop_rotation_view": 0,
            "crop_rotation_edit": 0,
            "crop_rotation_update_structure": 0,
            "crop_rotation_update_fields_shape": 0,
            "warehouse_view": 0,
            "warehouse_edit": 0
        }
    },

    [MockMethodsMap[ModulesMap.AUTH].LOGIN](request) {
        const loginData = {
            email: 'test@gmail.com',
            password: '1111'
        }

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (loginData.email === request.data.email && loginData.password === request.data.password) {
                    resolve({
                        success: true,
                        token: 'ababalamaga'
                    })
                } else {
                    resolve({
                        success: false,
                        message: 'Логин или пароль неправильные'
                    })
                }
            }, 200)
        })
    },

    [MockMethodsMap[ModulesMap.AUTH].REGISTER](request) {
        const alreadyRegistered = {
            email: 'test@gmail.com',
        }

        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (request.data.email === alreadyRegistered.email) {
                    resolve({
                        success: false,
                        formErrors: {
                            email: 'Этот E-mail уже используется'
                        }
                    })
                } else {
                    resolve({
                        success: true
                    })
                }
            }, 3000)
        })
    },

    [MockMethodsMap[ModulesMap.AUTH].LOGOUT](request) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(true)
            }, 1000)
        })
    },

}
